import { render } from "./actionable-rating-stars.html?vue&type=template&id=a82b1386"
import script from "./ActionableRatingStars.vue?vue&type=script&lang=ts"
export * from "./ActionableRatingStars.vue?vue&type=script&lang=ts"

import "./rating-stars.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script